export default __webpack_public_path__ + "static/media/investor1.a19045b2.png";